import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import ECardAddFile from './ECardAddFile';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import { ECardType } from '../../Enums/ECardType.enum';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean, folderId: string) => void;
	targetPatientId?: string;
	patientId: string;
	workplaceId?: string;
	defaultData?: any;
	params?: any;
	eCardType: ECardType;
}

const ECardAddFileModal: React.FC<Props> = ({
	opened,
	onClose,
	patientId,
	targetPatientId,
	eCardType,
}) => {
	const { isCase } = useTreatmentContext();

	return (
		<div>
			<Modal opened={opened} onClose={onClose} wrapChat={isCase}>
				<Modal.Header title={'component.uploadDocumentForm.title'} />
				<Modal.Content>
					<ECardAddFile
						targetPatientId={targetPatientId}
						patientId={patientId}
						onSuccess={onClose}
						eCardType={eCardType}
					/>
				</Modal.Content>
			</Modal>
		</div>
	);
};

export default ECardAddFileModal;
